<template>
  <v-container>
    <v-row class="mb-n6">
      <v-col>
        <p>ປະຫວັດການແກ້ໄຂລູກຄ້າທຸລະກິດ</p>
      </v-col>
    </v-row>

    <v-card class="mt-6">
      <v-card-title>
        <v-row>
          <v-col
            cols="12"
            md="3"
          >
            <v-menu
              v-model="fromMenu"
              :close-on-content-click="true"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="dateFrom"
                  label="ອະນຸມັດແຕ່ວັນທີ"
                  readonly
                  clearable
                  outlined
                  dense
                  hide-details
                  v-bind="attrs"
                  v-on="on"
                />
              </template>
              <v-date-picker v-model="dateFrom" />
            </v-menu>
          </v-col>
          <v-col
            cols="12"
            md="3"
          >
            <v-menu
              v-model="toMenu"
              :close-on-content-click="true"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="dateTo"
                  label="ຫາວັນທີ"
                  readonly
                  clearable
                  outlined
                  dense
                  hide-details
                  v-bind="attrs"
                  v-on="on"
                />
              </template>
              <v-date-picker
                v-model="dateTo"
                :min="dateFrom || undefined"
              />
            </v-menu>
          </v-col>
          <v-col
            cols="12"
            md="4"
          >
            <v-text-field
              v-model="filter"
              append-icon="mdi-magnify"
              label="ຄົ້ນຫາຊື່ບໍລິສັດ"
              outlined
              dense
              hide-details
              clearable
              @keyup.enter="fetchData(1)"
            />
          </v-col>
          <v-col
            cols="12"
            md="2"
          >
            <v-btn
              color="primary"
              block
              @click="fetchData(1)"
            >
              ຄົ້ນຫາ
            </v-btn>
          </v-col>
        </v-row>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="items"
        item-key="id"
        show-expand
        single-expand
        hide-default-footer
        disable-pagination
      >
        <template v-slot:[`item.customer_id`]="{ item }">
          <a @click="$openRoute({ name: 'ViewCompanyDetail', params: { id: item.customer_id } })">COM_{{ item.customer_id }}</a>
        </template>
        <template v-slot:[`item.fields`]="{ item }">
          {{ changeRows(item).map((r) => r.label).join(', ') || '—' }}
        </template>
        <template v-slot:[`item.submitter`]="{ item }">
          {{ item.submitter ? item.submitter.name : '' }}
        </template>
        <template v-slot:[`item.reviewer`]="{ item }">
          {{ item.reviewer ? item.reviewer.name : '' }}
        </template>
        <template v-slot:expanded-item="{ headers: cols, item }">
          <td
            :colspan="cols.length"
            class="py-3"
          >
            <v-simple-table dense>
              <thead>
                <tr>
                  <th>ຊ່ອງ</th>
                  <th>ກ່ອນແກ້</th>
                  <th>ຫຼັງແກ້</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="row in changeRows(item)"
                  :key="row.field"
                >
                  <td class="font-weight-bold">
                    {{ row.label }}
                  </td>
                  <td class="text--secondary">
                    {{ row.old }}
                  </td>
                  <td>{{ row.new }}</td>
                </tr>
              </tbody>
            </v-simple-table>
          </td>
        </template>
      </v-data-table>
      <Pagination
        v-if="pagination.total_pages > 1"
        :pagination="pagination"
        :offset="offset"
        @paginate="fetchData()"
      />
    </v-card>
  </v-container>
</template>

<script>
import { today } from '@/Helpers/localDate';
import { changeRows } from './editFields';

export default {
  title() {
    return 'Vientiane Waste Co-Dev|Company Edit History';
  },
  data() {
    return {
      items: [],
      filter: '',
      // Opens on today's approvals; clear the dates to see every day.
      dateFrom: today(),
      dateTo: today(),
      fromMenu: false,
      toMenu: false,
      offset: 12,
      pagination: {},
      requestSeq: 0,
      vehicleNames: {},
      headers: [
        { text: 'ລະຫັດ', value: 'customer_id', sortable: false },
        { text: 'ຊື່ບໍລິສັດ', value: 'company_name' },
        { text: 'ຊ່ອງທີ່ປ່ຽນ', value: 'fields', sortable: false },
        { text: 'ຜູ້ແກ້ໄຂ', value: 'submitter', sortable: false },
        { text: 'ຜູ້ອະນຸມັດ', value: 'reviewer', sortable: false },
        { text: 'ວັນເວລາອະນຸມັດ', value: 'reviewed_at' },
        { text: '', value: 'data-table-expand' },
      ],
    };
  },
  created() {
    this.fetchData();
    this.$axios.get('vehicle_type/')
      .then((res) => {
        this.vehicleNames = Object.fromEntries(res.data.data.map((v) => [v.id, v.name]));
      })
      .catch(() => {});
  },
  methods: {
    changeRows(item) {
      return changeRows(item.changes, { ...(item.labels || {}), vehicles: this.vehicleNames });
    },
    fetchData(page) {
      // Ignore responses to superseded searches (the API can be slow).
      const seq = ++this.requestSeq;
      if (page) this.$set(this.pagination, 'current_page', page);
      this.$store.commit('Loading_State', true);
      this.$axios
        .get('company-edit-request/history', {
          params: {
            page: this.pagination.current_page,
            per_page: 20,
            filter: this.filter || undefined,
            date_from: this.dateFrom || undefined,
            date_to: this.dateTo || undefined,
          },
        })
        .then((res) => {
          if (seq !== this.requestSeq) return;
          this.items = res.data.data.data;
          this.pagination = res.data.data.pagination;
        })
        .catch((error) => {
          const data = (error.response && error.response.data) || {};
          this.$store.commit('Toast_State', { value: true, color: 'error', msg: data.message || 'Something went wrong' });
        })
        .finally(() => {
          this.$store.commit('Loading_State', false);
        });
    },
  },
};
</script>
